import { message } from "antd";
import Router from "../..";
import { handleApiError } from "./indexApi";

const BASE_URL = process.env.REACT_APP_API_URL_PRO;

export const influencerApi = {
  registerTiktokCode: async (code) => {
    try {
      const token = localStorage.getItem("authorization");
      const res = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/influencer/connect/tiktok`,
        { code },
        { headers: { authorization: token } }
      );
      return res.data;
    } catch (err) {
      handleApiError(err, "틱톡 인증에 실패했습니다.");
      return null;
    }
  },

  searchInfluencers: async ({
    page = 1,
    follower = null,
    keyword = null,
    category = null,
    sort = "follower",
    region = null,
    gender = null,
  } = {}) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/influencer/search`,
        // "https://api.surfingcre.com/surfingcre/api/v1/influencer/search",
        {
          params: {
            page,
            follower,
            keyword,
            category,
            sort,
            region,
            gender,
          },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }
      return res.data;
    } catch (err) {
      handleApiError(err, "크리에이터 검색에 실패했습니다.");
      return null;
    }
  },

  getInfluencerDetail: async (unique_id) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/influencer/get/detail`,
        // "https://api.surfingcre.com/surfingcre/api/v1/influencer/get/detail",
        {
          params: { unique_id },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );

      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        throw new Error(res.data.error.text);
      }

      return res.data?.result || null;
    } catch (err) {
      throw err;
    }
  },

  getInfluencerDetailCached: async (unique_id) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/influencer/get/detail/cached`,
        // "https://api.surfingcre.com/surfingcre/api/v1/influencer/get/detail/cached",
        {
          params: { unique_id },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );

      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        throw new Error(res.data.error.text);
      }

      return res.data?.result || null;
    } catch (err) {
      throw err;
    }
  },

  // 카테고리 추가
  addCategory: async (categories, social) => {
    try {
      const res = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/influencer/add/category`,
        { categories, social },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );

      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return false;
      }

      if (res.data?.result) {
        message.success("카테고리가 추가되었습니다.");
        return true;
      }

      return false;
    } catch (err) {
      handleApiError(err, "카테고리 추가에 실패했습니다.");
      return false;
    }
  },

  // 카테고리 삭제
  deleteCategory: async (categories, social) => {
    try {
      const res = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/influencer/delete/category`,
        { categories, social },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );

      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return false;
      }

      if (res.data?.result) {
        message.success("카테고리가 삭제되었습니다.");
        return true;
      }

      return false;
    } catch (err) {
      handleApiError(err, "카테고리 삭제에 실패했습니다.");
      return false;
    }
  },

  // 나의 소셜 정보 불러오기
  getSocialInfo: async (social, tiktok_influencer_id) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/influencer/get/mysocial`,
        {
          params: { social, tiktok_influencer_id },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      return res.data?.result;
    } catch (err) {
      handleApiError(err, "나의 소셜 정보 불러오기에 실패했습니다.");
      return null;
    }
  },

  // 초대받은 에이전시 목록 조회
  getInvitedAgencies: async () => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/agency/get/invitation`,
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }
      return res.data;
    } catch (err) {
      handleApiError(err, "초대받은 에이전시 목록 조회에 실패했습니다.");
      return null;
    }
  },

  // 에이전시의 크리에이터 초대 수락
  acceptAgencyInvitation: async (company_id) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/agency/accept/invite`,
        { company_id },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        localStorage.setItem("authorization", data.result.authorization);
        localStorage.setItem("rauthorization", data.result.rauthorization);
        message.success("에이전시 초대가 수락되었습니다.");
        return true;
      }
      if (data.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "초대 수락에 실패했습니다.");
      return false;
    }
  },

  // 에이전시 떠나기
  leaveAgency: async () => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/agency/leave`,
        {},
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data.result) {
        localStorage.setItem("authorization", data.result.authorization);
        localStorage.setItem("rauthorization", data.result.rauthorization);
        message.success("에이전시에서 나갔습니다.");
        return true;
      }
      if (data?.error?.text) message.error(data.error.text);
      return false;
    } catch (err) {
      handleApiError(err, "에이전시 탈퇴에 실패했습니다.");
      return false;
    }
  },

  // 통장 사본 등록
  addBankAccountByInfluencer: async (
    bank_holder_name,
    bank_account_url,
    bank_account_number,
    bank_name
  ) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/influencer/add/bank`,
        { bank_holder_name, bank_account_url, bank_account_number, bank_name },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      return data.result;
    } catch (err) {
      handleApiError(err, "통장 사본 추가에 실패했습니다.");
      return false;
    }
  },

  // ai 분석 결과
  analyzeAiResult: async (unique_id) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/influencer/get/analyze`,
        // "https://api.surfingcre.com/surfingcre/api/v1/influencer/get/analyze",
        {
          params: { unique_id },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );

      const analysis = res.data?.result?.analysis;
      if (!analysis?.success) return null;

      return analysis.data;
    } catch (err) {
      handleApiError(err, "AI 분석 결과 조회에 실패했습니다.");
      return null;
    }
  },

  analyzeAiBrandFit: async ({ unique_id, is_update = false }) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/influencer/get/analyze/brandfit`,
        // "https://api.surfingcre.com/surfingcre/api/v1/influencer/get/analyze/brandfit",
        {
          params: { unique_id, is_update },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      const analysis = res.data?.result?.analysis;
      if (!analysis?.success) return null;
      return analysis.data;
    } catch (err) {
      handleApiError(err, "AI 브랜드 맞춤 분석 결과 조회에 실패했습니다.");
      return null;
    }
  },
  // 브랜드가 인플루언서 검색 시 크리에이터 추천
  getRecommendedInfluencers: async (
    follower,
    keyword,
    category,
    region,
    gender
  ) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/influencer/recommend`,
        {
          params: { follower, keyword, category, region, gender },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }
      return res.data?.result || null;
    } catch (err) {
      handleApiError(err, "크리에이터 추천에 실패했습니다.");
      return null;
    }
  },

  // 브랜드 캠페인 관리에서 인플루언서 상세 정보 보기 추가
  getInfluencerDetailById: async (id) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/influencer/get/detail/byid`,
        {
          params: { id },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }
      return res.data?.result;
    } catch (err) {
      handleApiError(err, "크리에이터 상세 정보 조회에 실패했습니다.");
      return null;
    }
  },

  // 인스타그램 연동
  registerInstagramCode: async (code) => {
    try {
      const res = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/influencer/connect/instagram`,
        { code },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );

      return res.data;
    } catch (err) {
      handleApiError(err, "인스타그램 인증에 실패했습니다.");
      return null;
    }
  },

  // 유튜브 연동
  registerYoutubeCode: async (code) => {
    try {
      const res = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/influencer/connect/youtube`,
        { code },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );

      if (res.data?.error) {
        message.error(res.data.error?.text || "유튜브 인증에 실패했습니다.");
        return null;
      }

      return res.data;
    } catch (err) {
      handleApiError(err, "유튜브 인증에 실패했습니다.");
      return null;
    }
  },
};
